import type { ResponseVaults } from "@/hooks/data/useMapVaults";
import type { Strategies } from "@/../config/swr.config";
import type { SupSingleVaultV3 } from "@/types";

import useApi from "@/hooks/api/useApi";
import useMapVaults from "@/hooks/data/useMapVaults";

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-0029995a-4bdb-4b7b-b16d-e443c64d19c7?ctx=documentation
 */
export default function useVaults(strategy: Strategies = "on-mount", enabled: boolean = true) {
  const { data, isLoading, isError, mutate } = useApi<SupSingleVaultV3[], ResponseVaults[]>(
    {
      path: `/vaults/`,
      api: "v2",
    },
    {
      enabled,
      strategy,
      select: useMapVaults,
    }
  );

  return {
    data,
    isLoading,
    isError,
    mutate,
  };
}
